import { Webapi } from '@/Webapi'

export const getLock = () => import('auth0-lock').then(({ default: Auth0Lock }) => Auth0Lock)

export const getOptions = () => Webapi().path('auth0').get()

export const login = ([
    Auth0Lock,
    { 'auht0-login-audience': aud, 'auth0-client-id': cid, 'auth0-web-login-domain': domain },
]) => {
    const options = {
        closable: false,
        auth: {
            audience: aud,
            redirectUrl: `${window.location.origin}/login/session`,
            responseType: 'token id_token',
            scope: 'openid',
        },
        theme: {
            logo:
                'https://carrier-images.s3.amazonaws.com/buyers/logo/3ca5ddff-a3a3-46f1-a78b-7a11418b4755.png',
            primaryColor: '#39c69b',
        },
        languageDictionary: {
            title: '',
        },
    }

    new Auth0Lock(cid, domain, options).show()
}
